import Concerns from './component';

export default {
  path: 'concerns',
  component: Concerns,
};



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/Concerns/routes.js